/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV0CompanyGetLastDataUpdatesGet$Json$Params {
  companyId?: string;
  lastSyncDate?: string;
}

export function apiV0CompanyGetLastDataUpdatesGet$Json(http: HttpClient, rootUrl: string, params?: ApiV0CompanyGetLastDataUpdatesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
  const rb = new RequestBuilder(rootUrl, apiV0CompanyGetLastDataUpdatesGet$Json.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
    rb.query('lastSyncDate', params.lastSyncDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<number>>;
    })
  );
}

apiV0CompanyGetLastDataUpdatesGet$Json.PATH = '/api/v0/company/getLastDataUpdates';
